// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3t-5q","inner":"styles_inner__gVE4d","right":"styles_right__3RNbt","close":"styles_close__3D8uB","footer":"styles_footer__3o-Dm"};